import './App.css';
import React from "react";
import { Switch, Route } from "react-router-dom";
import {db, auth} from './firebase.js';
import {useEffect, useState} from 'react';
import Header from "./Header";
import Perfil from "./Perfil";
import Stories from "./Stories";
import Post from "./Post";
import {BrowserRouter} from 'react-router-dom';
import Messenger from './Messenger';
import EmojiPicker from 'emoji-picker-react';

function App() {
  
  const [user, setUser] = useState();

  const [posts, setPosts] = useState([]);

    useEffect(()=>{

      auth.onAuthStateChanged(function(val){
          if(val!=null){
            setUser(val.displayName);
          }    
      })
      db.collection('posts').orderBy('timestamp','desc').onSnapshot(function(snapshot){
        setPosts(snapshot.docs.map(function(document){
          return {id:document.id,info:document.data()}
        }))
      })
      
    },[])


    return (
    <div className="App">
      <BrowserRouter>  
        <Switch>
            <Route exact path="/">
                <Header setUser={setUser} user={user}/>
                {
                  posts.map(function(val){

                  return (
                  <Post user={user} info={val.info} id={val.id}/>
                  )
                  })
                }
            </Route> 
            <Route exact path="/perfil">
                <Perfil setUser={setUser} user={user}/>
            </Route>
            <Route>
                <Stories/>
            </Route>
            <Route exact path="/messenger">
                <Messenger/>
            </Route>
           
        </Switch>
        
      </BrowserRouter>  
    </div>

    
     
    
    
  );
}

export default App;

